/**
 * Hata kodlari ve Turkce, insan diliyle yazilmis karsiliklari.
 * Kural: kullaniciya asla teknik metin gosterilmez; API her zaman
 * { hata: { kod, mesaj, alan? } } dondurur ve UI mesaji oldugu gibi basar.
 */
export const HATA_MESAJLARI = {
  YETKISIZ: 'Bu işlem için yetkiniz yok. Yöneticinize danışın.',
  KIMLIK_HATALI: 'E-posta veya parola hatalı. Tekrar deneyin.',
  HESAP_KILITLI: 'Hesabınız geçici olarak kilitlendi. Birkaç dakika sonra tekrar deneyin.',
  OTURUM_SURESI_DOLDU: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
  KAYIT_BULUNAMADI: 'Aradığınız kayıt bulunamadı.',
  ROL_ATANAMAZ: 'Kendi yetkinizin üzerinde bir rol veremezsiniz.',
  KENDINI_DEGISTIREMEZ: 'Kendi rolünüzü veya erişiminizi buradan değiştiremezsiniz. Başka bir yönetici yapmalı.',
  SON_SAHIP: 'Tesiste en az bir aktif sahip kalmalı.',
  GECERSIZ_VERI: 'Girilen bilgilerde eksik veya hatalı alan var.',
  KAPORA_KARARI_GEREKLI: 'Bu rezervasyonun kaporası var. İptal etmeden önce kaporanın iade mi edildiğini, otelde mi kaldığını seçin.',
  REZERVASYON_KAPALI: 'Ayrılmış veya iptal edilmiş rezervasyonda yalnızca not değiştirilebilir.',
  GIRIS_TARIHI_KILITLI: 'Misafir içeride olduğu için giriş tarihi değiştirilemez. Çıkış tarihini uzatabilirsiniz.',
  ODA_DOLU: 'Bu oda seçilen tarihlerde dolu. Başka bir oda seçin.',
  CIFT_REZERVASYON: 'Bu oda az önce başkası tarafından verildi. Oda planını yenileyin.',
  OCR_OKUNAMADI: 'Kimlik okunamadı. Belgeyi düz tutup tekrar deneyin ya da bilgileri elle girin.',
  OCR_ZAMAN_ASIMI: 'Kimlik okuma uzun sürdü. Bilgileri elle girebilirsiniz.',
  OCR_KOTA_DOLDU: 'Bugünkü kimlik okuma hakkınız doldu. Bilgileri elle girebilirsiniz.',
  GORSEL_COK_BUYUK: 'Fotoğraf çok büyük. Lütfen tekrar çekin.',
  GORSEL_GECERSIZ: 'Bu dosya bir fotoğraf değil. JPEG veya PNG gönderin.',
  BELGE_COK_BUYUK: 'Dosya çok büyük. En fazla 8 MB gönderebilirsiniz.',
  BELGE_GECERSIZ: 'Bu dosya tipi kabul edilmiyor. JPEG, PNG, WebP veya PDF gönderin.',
  KIMLIK_DOGRULANAMADI: 'Bu odada bu kimlik numarasıyla kayıtlı bir misafir bulunamadı. Resepsiyona danışın.',
  KIMLIK_COK_DENEME: 'Çok fazla deneme yapıldı. 15 dakika sonra tekrar deneyin.',
  RAHATSIZ_ETMEYIN: 'Misafir "rahatsız etmeyin" işaretlemiş. Kaldırılana kadar odaya girilmez.',
  KBS_EKSIK_ALAN: 'KBS bildirimi için zorunlu alanlar eksik. Sarı işaretli alanları doldurun.',
  KBS_GONDERIM_HATASI: 'KBS bildirimi gönderilemedi. Sistem tekrar deneyecek.',
  KBS_YAPILANDIRMA_EKSIK:
    'Resmi web servisi için tesis kodu, yetkili T.C. numarası ve web servis şifresinin üçü de tanımlı olmalı.',
  PARASUT_YETKI_GEREKLI: 'Paraşüt bağlantısının yetkisi düşmüş. Ayarlar > e-Fatura bölümünden yeniden bağlanın.',
  PARASUT_ULASILAMADI: 'Paraşüt\'e ulaşılamadı. Fatura kaydedildi, bağlantı gelince tekrar denenecek.',
  PARASUT_HATASI: 'Paraşüt isteği reddetti. Ayrıntı için API günlüğüne bakın.',
  PARASUT_KAPALI: 'Bu tesiste e-Fatura entegrasyonu tanımlı değil.',
  FOLYO_KAPALI_DEGIL: 'Fatura kesmek için folyonun kapatılmış olması gerekir.',
  FATURA_ZATEN_VAR: 'Bu folyo için zaten bir fatura kesilmiş.',
  SUNUCU_HATASI: 'Beklenmeyen bir sorun oluştu. Tekrar deneyin.',
  CEVRIMDISI: 'İnternet bağlantısı yok. İşlem kaydedildi, bağlantı gelince gönderilecek.',
  KOTA_ASILDI: 'İstek sınırı aşıldı. Biraz bekleyip tekrar deneyin.',

  // --- platform / cok kiracilik
  TESIS_BULUNAMADI: 'Bu adrese bağlı bir tesis bulunamadı. Adresi kontrol edin.',
  TESIS_ASKIDA: 'Tesis hesabı askıya alınmış. Lütfen bizimle iletişime geçin.',
  TESIS_IPTAL: 'Bu tesis hesabı kapatılmış.',
  ADRES_KULLANIMDA: 'Bu adres başka bir tesis tarafından kullanılıyor. Başka bir adres seçin.',
  EPOSTA_KULLANIMDA: 'Bu e-posta adresi bu tesiste zaten kayıtlı.',
  PLATFORM_YETKISIZ: 'Bu işlem için platform yöneticisi yetkisi gerekiyor.',
  YANLIS_TESIS: 'Oturumunuz başka bir tesise ait. Doğru adresten giriş yapın.',
  ODA_NO_KULLANIMDA: 'Bu oda numarası zaten kullanılıyor.',
  ODA_GECMISI_VAR: 'Bu odada geçmiş rezervasyon var; silinemez. Kullanımdan kaldırabilirsiniz.',
  ODA_LIMITI_ASILDI: 'Planınızın oda limiti doldu. Yükseltmek için bizimle iletişime geçin.',

  // --- telefonla kimlik tarama
  ESLESME_BULUNAMADI: 'Bu kod geçersiz ya da başka bir telefon tarafından kullanılmış. Masadan yeni bir kare kod isteyin.',
  ESLESME_SONA_ERDI: 'Telefon eşleşmesi sona erdi. Masadaki ekrandan yeniden kare kod okutun.',
} as const;

export type HataKodu = keyof typeof HATA_MESAJLARI;

export interface ApiHata {
  hata: { kod: HataKodu; mesaj: string; alan?: string; detay?: unknown };
}

export function apiHata(kod: HataKodu, alan?: string, detay?: unknown): ApiHata {
  return { hata: { kod, mesaj: HATA_MESAJLARI[kod], ...(alan ? { alan } : {}), ...(detay ? { detay } : {}) } };
}

export class HotelError extends Error {
  constructor(
    public readonly kod: HataKodu,
    public readonly status: number = 400,
    public readonly alan?: string,
    public readonly detay?: unknown,
  ) {
    super(HATA_MESAJLARI[kod]);
    this.name = 'HotelError';
  }
  toJSON(): ApiHata {
    return apiHata(this.kod, this.alan, this.detay);
  }
}
